export * from './events';

export class PubSub {
    private static listeners = {};

    static subscribe(topic: string, listener: any): string {
        const subToken = PubSub.genSubToken();
        PubSub.listeners[subToken] = { topic, listener };
        window.addEventListener(topic, listener);
        return subToken;
    }

    static unSubscribe(subToken: string): boolean {
        const target = PubSub.listeners[subToken];
        if (!target) {
            return false;
        }
        const { topic, listener } = target;
        window.removeEventListener(topic, listener);
        return true;
    }

    static publish(topic: string, data: any): boolean {
        const event = new CustomEvent(topic, { detail: data });
        return window.dispatchEvent(event);
    }

    static genSubToken(): string {
        const { crypto } = window;
        const array = crypto.getRandomValues(new Uint32Array(1));
        return crypto.getRandomValues(array).toString();
    }
}
